// extracted by mini-css-extract-plugin
export default {"input":"StyledInputNumber_input__-Wi5w"};